module.exports = __webpack_public_path__ + "media/application/images/technology/secondary_nav/how-it-works-aa6a9ba9a8de26b22f5210e0cc71bb4d.jpg";